module.exports = [{"name":"Presentation 2019","file":"/static/files/presentations/2019_alcomet.pdf","img":"/static/files/presentations/2019_alcomet.jpg","date":"29.08.2019"},{"name":"Alcomet Catalogo","file":"/static/files/catalogues/catalogue_alcomet.pdf","img":"/static/files/catalogues/catalogue_alcomet.jpg","date":"01.01.2016"},{"name":"Presentation 2017","file":"/static/files/catalogues/2017_alcomet.pdf","img":"/static/files/catalogues/2017_alcomet.jpg","date":"01.01.2017"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/download-center/catalogues.json
// module id = pZMA
// module chunks = 1